<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-c2">
    <p>
      <strong>{{ 'password.recovery.method.sms.title' | translate }}</strong>
    </p>
    <p class="rs-padding-bottom1">
      {{ 'password.recovery.method.sms.active.description' | translate }}
    </p>

    <div class="rs-flex-row rs-flex-collapse rs-flex-middle" *ngIf="!showChangeNumber">
      <div class="rs-flex-columns small-9">
        <p>
          <strong class="rs-word-break-all">{{ mobileNumber }}</strong>
        </p>
      </div>
      <div class="rs-flex-columns small-3">
        <p class="text-right">
          <button
            (click)="showChangeNumber = !showChangeNumber"
            class="rs-link-action rs-link-action-edit"
            data-cy="passwordRecoveryEditButton"
          >
            <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">{{
              'password.recovery.method.sms.pending.edit' | translate
            }}</span
            ><span class="rs-action-link-icon" title="Edit"></span>
          </button>
        </p>
      </div>
    </div>

    <span *ngIf="showChangeNumber">
      <mprd-mobile-number-submit
        (mobileNumberSubmitFormStatusAndValue)="onMobileNumberSubmitFormStatusAndValue($event)"
        (mobileNumberSubmitCancel)="onMobileNumberSubmitCancel()"
      >
      </mprd-mobile-number-submit>
    </span>
  </div>
</div>
